
import TextInput from '@marketplace/components/forms/inputs/text-input.vue'
import { COMPANY_SETTINGS } from '@marketplace/config/retailerSignup.js'
import { BNPL_MODAL_UPDATE } from '@marketplace/graphql/checkout.js'
import checkoutMixin from '@marketplace/mixins/checkoutMixin.js'
import { EventBus } from '@marketplace/plugins/event-bus.js'
import { required, requiredIf } from 'vuelidate/lib/validators'
import { mapGetters } from 'vuex'

export default {
    name: 'ModalBnplCheckout',

    components: {
        TextInput,
    },

    mixins: [checkoutMixin],

    props: {
        registeredCompanyName: {
            type: String,
            required: true,
        },
        address: {
            type: Object,
            required: true,
        },
        paymentMethod: {
            type: Object,
            required: true,
        },
    },

    data() {
        return {
            isSubmitting: false,
            errorMessage: null,
            form: {
                cocNumber: null,
                registeredCompanyName: this.registeredCompanyName,
                street: this.address?.street || '',
                houseNumber: this.address?.houseNumber || '',
                postalCode: this.address?.postalCode || '',
                city: this.address?.city || '',
            },
            retailerOrder: null,
        }
    },

    computed: {
        ...mapGetters('global', ['account']),

        cocFieldName() {
            const country = this.account?.country?.toUpperCase()
            const countrySetting =
                COMPANY_SETTINGS[country] || COMPANY_SETTINGS.default

            return countrySetting?.vatFields?.coc
        },

        paymentMethodId() {
            return this.paymentMethod.id
        },

        /**
         * Company settings are in an external config. If a country has a specific set of settings it will use those settings, or defaults to a general object
         *
         * @returns {object}
         */
        companySettings() {
            const country = this.account?.country?.toUpperCase()
            return COMPANY_SETTINGS[country] || COMPANY_SETTINGS.default
        },

        chosenPaymentProvider() {
            return this.paymentMethod?.name
        },

        isCocRequired() {
            return (
                this.companySettings.vatFields?.coc &&
                this.paymentMethodId === 'mondu-authorization'
            )
        },
        showCoc() {
            return (
                this.companySettings.vatFields?.coc &&
                this.paymentMethodId !== 'billie-authorization'
            )
        },
    },

    created() {
        this.form.cocNumber = this.showCoc ? this.account?.cocNumber : null
    },

    validations() {
        return {
            form: {
                registeredCompanyName: { required },
                cocNumber: {
                    required: requiredIf(function () {
                        return this.isCocRequired
                    }),
                    minLength: 9,
                },

                street: { required },
                houseNumber: { required },
                postalCode: { required },
                city: { required },
            },
        }
    },

    methods: {
        closeModal() {
            EventBus.$emit('modal-close')
        },

        checkForNumber(value) {
            return /\d/.test(value)
        },

        submit() {
            this.$v.$touch()

            if (this.$v.$invalid) {
                return
            }

            this.isSubmitting = true

            this.$apollo
                .mutate({
                    mutation: BNPL_MODAL_UPDATE,
                    variables: {
                        registeredCompanyName: this.form.registeredCompanyName,
                        street: this.form.street,
                        houseNumber: this.form.houseNumber,
                        postalCode: this.form.postalCode,
                        city: this.form.city,
                        cocNumber: this.form.cocNumber,
                    },
                })
                .then((data) => {
                    const userErrors = data.data?.bnplModalUpdate?.userErrors

                    if (userErrors) {
                        this.isSubmitting = false
                        this.handleErrors(userErrors)
                    } else {
                        this.convertToOrder()
                    }
                })
        },

        handleErrors(userErrors) {
            if (userErrors) {
                this.errorMessage = userErrors
                    .map((item) => item.message)
                    .join(', ')
            } else {
                this.errorMessage = this.$t('messages.critical_gql_error')
            }
        },
    },
}
